// extracted by mini-css-extract-plugin
export default {"articleTitle":"ArticleTitle_articleTitle__ctX75","title":"ArticleTitle_title__y25g3","subTitle":"ArticleTitle_subTitle__ZqwCp","description":"ArticleTitle_description__2i4Zv"};